import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const SET_POST_COUNT = 'postListWidgetPostCount/SET';

export const setPostCount = createAction(SET_POST_COUNT);
